import { SET_LOYLATITY_CUSTOMER_DETAIL } from '../actions';

const loyaltycustomerdetail = (state = [], action) => {
  switch (action.type) {
    case SET_LOYLATITY_CUSTOMER_DETAIL:
      return [...action.value];
    default: return state;
  }
}

export default loyaltycustomerdetail;
